.option {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 4px 16px;
}
.option:hover {
  background-color: var(--color-easil-gray-xx-light);
}

.selected {
  line-height: 1;
  margin-left: 16px;
}

.name {
  color: var(--color-easil-black);
}
